import React from 'react';
import Home from './pages/home'
import News from './pages/news'
import Contact from './pages/contact'
import Article from './pages/article'
import CustomPage from './pages/custom-page'
import { Routes, Route } from 'react-router-dom'
import LanguageHandler from './helpers/language-handler'
import Loading from './includes/loading'
import Navbar from './includes/navbar'
import Footer from './includes/footer'

export default function App() {
    return (
        <>
            <LanguageHandler />
            <Loading />
            <Navbar/>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/news' element={<News />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/news/:id' element={<Article />} />
                <Route path='/*' element={<CustomPage />} />
            </Routes>
            <Footer />
        </>
    );
}